export default __webpack_public_path__ + "static/media/Chronic-Kidney-Disease-Management-2.ba3c4273.jpg";